import React from "react";
import { FOOTER_TEXT, FOOTER_CREDIT } from "../common/branding";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-px-4">
        <span className="tw-text-sm tw-text-slate-500">
          {FOOTER_TEXT || `© ${currentYear} FieldTrix. All rights reserved.`}
        </span>
        <span className="tw-hidden tw-text-sm tw-text-slate-500 sm:tw-block">
          {FOOTER_CREDIT || "Made with"}
          {!FOOTER_CREDIT && (
            <span className="tw-mx-1 tw-text-rose-500">❤️</span>
          )}
          {!FOOTER_CREDIT && " by FieldTrix Team"}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
